import { Component, inject, OnInit, ViewChild, signal } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@devinforius/super-compos-17';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import * as async from 'async';
import { NgxSpinnerService } from 'ngx-spinner';
import { SuperRichEditComponent } from '@devinforius/super-compos-17';
import { ApiService } from 'src/app/core/services/api.service';
import { Participant } from 'src/app/shared/models/participant';
import { IContactService } from 'src/app/core/services/i-contact.service';
import { Contact } from 'src/app/shared/models/iContact/contact';
import { DocumentEditorService } from 'src/app/core/services/document-editor.service';
import { ToastrService } from 'ngx-toastr';
import { LabelValue } from 'src/app/shared/models/labelvalue';
import { DataService } from 'src/app/core/services/data.service';
import { Global_Class } from 'src/app/shared/models/global';
import { Point } from 'src/app/shared/models/point';
import { ConfirmationService } from 'primeng/api';
import { UserContact } from 'src/app/shared/models/iContact/user-contact';
import { IDelibeManagementService } from 'src/app/core/services/idelibe/management.service';
import { IDelibeGlobalService } from 'src/app/core/services/idelibe/global.service';
import { TemplateFusionChamps } from 'src/app/shared/models/global/template-fusion-champs';
import { IGlobalElements } from 'src/app/shared/models/common/IGlobalElements';
import { ParticipantLowInfo } from 'src/app/shared/models/participantLowInfo';
import { ModeledEvents } from 'src/app/shared/models/management/modeles-events';
import { Meeting } from 'src/app/shared/models/meeting';
import { DocumentFormatApi } from 'devexpress-richedit/lib/model-api/formats/enum';
import { SsoService } from '@devinforius/i-sso';
import { DocumentsService } from '@shared/services/documents.service';
import { EventDocumentModelDto } from '@shared/interfaces/dtos/events';
import { finalize } from 'rxjs';
import { Notifier } from 'src/app/core/services';
import { NotificationError } from 'src/app/core/models';
@Component({
  selector: 'app-event-add',
  templateUrl: './event-add.component.html',
  styleUrls: ['./event-add.component.scss'],
})
export class EventAddComponent implements OnInit {
  private readonly documentsService = inject(DocumentsService);
  private readonly notifier = inject(Notifier);

  public meetingId: number = null;
  public header = null;
  public types = [];
  public numbers = [];

  public form: UntypedFormGroup = new UntypedFormGroup({
    PointId: new UntypedFormControl(null, Validators.required),
    participants: new UntypedFormArray([]),
    TexteRtf: new UntypedFormControl(null),
  });

  public participants = [];
  public participantsChosenEntree = [];
  public participantsChosenSortie = [];
  @ViewChild('document_editor') public documenteditorcontainer: SuperRichEditComponent;
  public token;
  public contacts: Array<Contact> = [];
  public usersAdmin: Array<UserContact> = [];
  public mode: string = 'create';
  public eventToPatch;
  public entry_exit_LV: Array<LabelValue> = [
    {
      label: 'Entrée',
      value: 'E',
    },
    {
      label: 'Sortie',
      value: 'S',
    },
  ];
  public globalElements: Global_Class = null;
  public listOfModelesEvent = [];
  public typeSeanceId: number;
  languageRichEdit: string;

  public readonly fetchingEventDocumentModels = signal<boolean>(false);
  public readonly eventDocumentModels = signal<EventDocumentModelDto[]>([]);
  public readonly selectedEventDocumentModel = signal<EventDocumentModelDto | null>(null);

  constructor(
    private ssoService: SsoService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public translate: TranslateService,
    public spinner: NgxSpinnerService,
    public api: ApiService,
    public IDelibeGlobalService: IDelibeGlobalService,
    public IDelibeManagementService: IDelibeManagementService,
    public contactService: IContactService,
    public editorService: DocumentEditorService,
    public toastr: ToastrService,
    public dataService: DataService,
    public confirmationService: ConfirmationService
  ) {
    this.token = this.ssoService.accessToken();
  }
  get f() {
    return this.form.controls;
  }

  get getParticipants(): UntypedFormArray {
    return this.form.get('participants') as UntypedFormArray;
  }
  isEventDocumentModelsDropdownShown = false;
  public modeleDocChosen = null;
  public fusions: TemplateFusionChamps;
  ngOnInit(): void {
    this.spinner.show();
    const language = JSON.parse(sessionStorage.getItem('langue'));
    this.languageRichEdit = language.codeLangue.toLowerCase();
    this.getFusionsField();
    async.waterfall(
      [
        (callback) => {
          this.dataService.getGlobalElements.subscribe((res: IGlobalElements) => {
            this.globalElements = new Global_Class(res);
            if (this.globalElements.isLoaded()) {
              callback(null);
            }
          });
        },
        (callback) => {
          this.header = this.config.data.header;
          this.meetingId = this.config.data?.meetingId;
          this.mode = this.config.data?.mode ? this.config.data.mode : 'create';
          console.log(this.config);

          if (this.mode === 'update') {
            this.eventToPatch = this.config.data?.event;
            if (this.eventToPatch.details.length > 0) {
              this.eventToPatch.details.map(() => {
                this.add();
              });
            }
            this.form.patchValue({
              PointId: this.eventToPatch?.avantPointId,
              participants: this.eventToPatch.details,
            });

            const blob = new Blob([this.eventToPatch?.texteRtf], { type: 'application/rtf' });
            if (this.documenteditorcontainer) {
              this.documenteditorcontainer.rich.openDocument(blob, 'document', DocumentFormatApi.Rtf, (cb) => {
                if (cb) {
                  this.spinner.hide();
                }
              });
            }
          } else {
            this.form.patchValue({
              PointId: this.config.data?.source ?? null,
            });
          }
          callback();
        },
        (callback) => {
          if (this.config.data.points) {
            this.numbers = this.config.data.points
              .filter((x) => {
                return !x.isTitle && !x.isIntroduction && !x.isConclusion && x.type !== 'event';
              })
              .map((x) => {
                return { label: (x.ordre ? x.ordre : '') + ' ' + x.title, value: x.id };
              });
            callback();
          } else {
            this.api.getMeetingsPointsInclus(this.meetingId).subscribe((res: any) => {
              const points = res.points.map((x) => {
                x.point.ordreReel = x.ordreReel;
                return new Point(x.point);
              });
              this.numbers = points.map((x) => {
                return { label: (x.ordre ? x.ordre : '') + ' ' + x.title, value: x.id };
              });
              callback();
            });
          }
        },
        (callback) => {
          if (this.config.data.typeSeanceId) {
            this.typeSeanceId = this.config.data.typeSeanceId;
            callback();
          } else {
            this.api.getMeetingsByID(this.meetingId).subscribe((res: Meeting) => {
              this.typeSeanceId = res.typeSeanceId;
              callback();
            });
          }
        },
        (callback) => {
          this.types = [{ label: this.translate.translate('before_label'), value: 'before' }];
          callback();
        },
        (callback) => {
          this.contactService.getUserWithDataAdmin().subscribe(
            (res: UserContact[]) => {
              this.usersAdmin = res;
              callback();
            },
            (error) => {
              console.error(error);
            }
          );
        },
        (callback) => {
          this.contactService.getLowContacts().subscribe(
            (contacts) => {
              this.contacts = contacts;
              callback();
            },
            (error) => {
              console.error(error);
            }
          );
        },
        (callback) => {
          if (this.meetingId) {
            this.api.getParticipantsByMeetingID(this.meetingId).subscribe((res: ParticipantLowInfo[]) => {
              this.participants = res.map((x) => new Participant(x, this.contacts, this.usersAdmin));
              callback();
            });
          } else {
            callback();
          }
        },
      ],
      () => {
        //Autant attendre le plus possible que l'éditeur soit présent dans le DOM
        if (this.documenteditorcontainer && this.mode === 'update') {
          const blob = new Blob([this.eventToPatch?.texteRtf], { type: 'application/rtf' });
          this.documenteditorcontainer.rich.openDocument(blob, 'event', DocumentFormatApi.Rtf);
        }
        this.spinner.hide();
      }
    );
  }

  getFusionsField() {
    this.IDelibeGlobalService.getGlobalFusionsFields().subscribe((res: TemplateFusionChamps) => {
      this.fusions = res;
    });
  }

  submitEvent(mode) {
    let texteRtf = null;
    if (this.form.valid) {
      this.spinner.show();
      async.waterfall([
        (cb) => {
          if (this.documenteditorcontainer) {
            this.documenteditorcontainer.rich.exportToFile((file) => {
              const blob = new Blob([file], { type: 'application/rtf' });
              const reader = new FileReader();
              reader.onload = function () {
                texteRtf = reader.result;
                cb(null);
              };
              reader.readAsText(blob);
            }, DocumentFormatApi.Rtf);
          }
        },
        (cb) => {
          this.form.patchValue({
            TexteRtf: texteRtf,
          });
          cb(null);
        },
        () => {
          this.removeEventWithNoParticipant().then(() => {
            if (mode === 'create') {
              this.api.postEventByMeetingID(this.meetingId, this.form.value).subscribe(
                () => {
                  this.toastr.success("L'évènement à bien été ajouté à la séance");
                  this.ref.close(true);
                  this.spinner.hide();
                },
                () => {
                  this.spinner.hide();
                  this.toastr.error("Une erreur s'est produite");
                }
              );
            } else {
              this.api.putEventByMeetingID(this.meetingId, this.eventToPatch.id, this.form.value).subscribe(
                () => {
                  this.toastr.success("L'évènement à bien été mis à jour");
                  this.ref.close(true);
                  this.spinner.hide();
                },
                () => {
                  this.spinner.hide();
                  this.toastr.error("Une erreur s'est produite");
                }
              );
            }
          });
        },
      ]);
    } else {
      this.toastr.error('Veuillez choisir un point');
    }
  }

  removeEventWithNoParticipant() {
    return new Promise((resolve) => {
      const indexesToDelete = [];
      // firstly we get all the indexes to delete
      this.form.value.participants?.map((x, i) => {
        if (x.participantId === null) {
          indexesToDelete.push(i);
        }
      });
      if (indexesToDelete.length > 0) {
        //then we reverse the array and remove the items from the formArray
        //! We HAVE to reverse because if we don't, and remove in the asc order, the array of participants will move and the 3rd item will be 2nd... indexes won't match anymore
        //! if we reverse, and delete for ex the 4th one, only items after will move!
        indexesToDelete.reverse().map((x) => {
          this.getParticipants.removeAt(x);
        });
        resolve(true);
      } else {
        resolve(true);
      }
    });
  }

  add() {
    this.getParticipants.push(
      new UntypedFormGroup({
        participantId: new UntypedFormControl(null),
        entreeSortie: new UntypedFormControl(null),
        roleId: new UntypedFormControl(null),
        signatureId: new UntypedFormControl(null),
      })
    );
  }

  remove(index) {
    this.getParticipants.removeAt(index);
  }

  showEventDocumentModelsDropdown() {
    this.isEventDocumentModelsDropdownShown = true;

    this.fetchEventDocumentModels();
  }

  private fetchEventDocumentModels(): void {
    this.fetchingEventDocumentModels.set(true);

    this.documentsService
      .fetchEventDocumentModels({ meetingTypeId: this.typeSeanceId })
      .pipe(finalize(() => this.fetchingEventDocumentModels.set(false)))
      .subscribe({
        next: (res) => {
          this.eventDocumentModels.set(res);
        },
      });
  }

  public proposeToUserToReplaceTextByDocumentModelContent(): void {
    this.confirmationService.confirm({
      message:
        'Attention, si vous acceptez, le texte ci-dessous sera complètement remplacé par le texte du modèle. Êtes-vous sûr de vouloir le remplacer?',
      key: 'addEventConfirm',
      accept: () => {
        const selectedEventDocumentModel = this.selectedEventDocumentModel();

        console.log(selectedEventDocumentModel);

        if (!selectedEventDocumentModel) return;

        this.replaceEditorContentByDocumentModel(selectedEventDocumentModel.id);
      },
      reject: () => {
        this.selectedEventDocumentModel.set(null);
      },
    });
  }

  private replaceEditorContentByDocumentModel(documentModelId: number): void {
    this.documentsService.downloadEventDocumentModelRTF(documentModelId).subscribe({
      next: (blob) => {
        if (this.documenteditorcontainer) {
          this.documenteditorcontainer.rich.openDocument(blob, 'document', DocumentFormatApi.Rtf);
        }
      },
      error: (err) => {
        console.info(err);
        this.notifier.showError(
          new NotificationError({ message: 'Une erreur est survenu lors de la récupération du RTF' })
        );
      },
    });
  }

  // changeModeleEventRTF() {
  //   this.confirmationService.confirm({
  //     message:
  //       'Attention, si vous acceptez, le texte ci-dessous sera complètement remplacé par le texte du modèle. Êtes-vous sûr de vouloir le remplacer?',
  //     key: 'addEventConfirm',
  //     accept: () => {
  //       this.spinner.show();
  //       this.loadInfoOfModeleEventChosen();
  //     },
  //     reject: () => {
  //       this.modeleDocChosen = null;
  //     },
  //   });
  // }

  // loadInfoOfModeleEventChosen() {
  //   const rtf = this.listOfModelesEvent.find((x) => x.id === this.modeleDocChosen.id).evenementRtf;
  //   const blob = new Blob([rtf], { type: 'application/rtf' });
  //   if (this.documenteditorcontainer) {
  //     this.documenteditorcontainer.rich.openDocument(blob, 'document', DocumentFormatApi.Rtf, (cb) => {
  //       if (cb) {
  //         this.spinner.hide();
  //       }
  //     });
  //   }
  // }
}
